const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const PAYER_EMAIL_REQUIRED_MESSAGE = "Escribe el correo de la cuenta de MercadoPago que va a pagar.";
export const PAYER_EMAIL_INVALID_MESSAGE = "Ese correo no es válido. Revísalo, por ejemplo: pagos@tuempresa.com.";

export function normalizePayerEmail(value: string): string {
  return value.trim().toLowerCase();
}

export function payerEmailError(value: string): string | null {
  const email = normalizePayerEmail(value);
  if (!email) return PAYER_EMAIL_REQUIRED_MESSAGE;
  if (!EMAIL_RE.test(email)) return PAYER_EMAIL_INVALID_MESSAGE;
  return null;
}

export {
  directPayerEmailError,
  normalizeDirectPayerEmail,
} from "../../supabase/functions/mercadopago-direct-payment/payer-email";
